import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=0fae0634&"
import script from "./Professional.vue?vue&type=script&lang=ts&"
export * from "./Professional.vue?vue&type=script&lang=ts&"
import style0 from "./Professional.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports